import { FC, ReactNode, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { canLoadUmbracoConfig, ConfigActions, getUmbracoConfigLoadStatus } from '../../redux/config'
import { ConfigLoadingState } from '../../redux/config/types'
import { RootState } from '../../redux/types'
import { Button } from '../Button'
import { CenterChildren } from '../Center'
import { Result } from '../Result'
import { Spin, SpinSize } from '../Spin'

type OuterProps = {
  language: string
  alertImg: string
  children: ReactNode
}

type Props = OuterProps

export const ConfigGuard: FC<Props> = ({ language, children, alertImg }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const canStartLoading = useSelector((state: RootState) => canLoadUmbracoConfig(state, language))
  const loadStatus = useSelector(getUmbracoConfigLoadStatus)

  useEffect(() => {
    if (canStartLoading) {
      dispatch(
        ConfigActions.fetchContentConfiguration({
          lang: language,
          navigate
        })
      )
    }
  }, [canStartLoading, dispatch, language, navigate])

  if (loadStatus === ConfigLoadingState.Failed) {
    return (
      <Result
        imageSrc={alertImg}
        title="We are sorry"
        subTitle="Application config could not be loaded."
        extra={
          <CenterChildren>
            <Button
              variant="primary"
              onClick={() =>
                dispatch(
                  ConfigActions.fetchContentConfiguration({
                    lang: language,
                    navigate
                  })
                )
              }
            >
              Reload configuration
            </Button>
          </CenterChildren>
        }
      />
    )
  }

  if (loadStatus === ConfigLoadingState.Loaded) {
    return <>{children}</>
  }

  return (
    <CenterChildren height="100%" display="flex" alignContent="center">
      <Spin size={SpinSize.ExtraLarge} dotSize={50} />
    </CenterChildren>
  )
}
